module.exports = __webpack_public_path__ + "img/image33.7085d94a.png";